import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import classnames from 'classnames';

const withProps = IconComponent => {
  const WrappedComponent = _ref => {
    let {
      size,
      className,
      ...props
    } = _ref;
    const iconProps = {};
    if (className || size) {
      iconProps.className = classnames(className, {
        [`icon-${size}`]: size
      });
    }
    return /*#__PURE__*/React__default.createElement(IconComponent, _extends({}, iconProps, props));
  };
  WrappedComponent.displayName = `withProps(${IconComponent.displayName || IconComponent.name})`;
  return WrappedComponent;
};

export { withProps };
